import { Inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { DeadLetterDetail } from '../models/dead-letter-detail.model';
import { DeadLetterListItem } from '../models/dead-letter-list-item.model';
import { AppInsightsLogEntry } from '../models/dead-letter-logs.model';
import {
  DeadLetterQuery,
  DeadLetterSearchRequest,
  DeadLetterSearchResponse,
  DeadLetterBatchRequest,
  RemoveDeadLettersResult,
  ReplayDeadLettersResult
} from '../models/dead-letter-query.model';
import { API_BASE_URL } from '../../../injection-constants';

const PAGE_SIZE = 25;

@Injectable({ providedIn: 'root' })
export class DeadLetterService {
  constructor(private readonly http: HttpClient,
    @Inject(API_BASE_URL) private readonly apiBaseUrl: string) {}

  getDeadLetters(query: DeadLetterQuery): Observable<DeadLetterSearchResponse<DeadLetterListItem>> {
    const body: DeadLetterSearchRequest = {
      pageSize: PAGE_SIZE,
      continuationToken: query.nextPage,
      searchText: query.searchTerm || undefined,
      eventType: query.eventType || undefined,
      from: query.dateFrom?.toISOString(),
      to: query.dateTo?.toISOString()
    };

    return this.http.post<DeadLetterSearchResponse<DeadLetterListItem>>(
      `${this.apiBaseUrl}/api/deadletter/search`, body);
  }

  getDeadLetter(id: string): Observable<DeadLetterDetail> {
    return this.http.get<DeadLetterDetail>(`${this.apiBaseUrl}/api/deadletter/${id}`);
  }

  getDeadLetterLogs(id: string): Observable<AppInsightsLogEntry[]> {
    return this.http.get<AppInsightsLogEntry[]>(`${this.apiBaseUrl}/api/deadletter/${id}/logs`);
  }

  removeDeadLetters(request: DeadLetterBatchRequest): Observable<RemoveDeadLettersResult> {
    return this.http.post<RemoveDeadLettersResult>(
      `${this.apiBaseUrl}/api/deadletter/remove`, request);
  }

  replayDeadLetters(request: DeadLetterBatchRequest): Observable<ReplayDeadLettersResult> {
    return this.http.post<ReplayDeadLettersResult>(
      `${this.apiBaseUrl}/api/deadletter/replay`, request);
  }
}
